import "./App.css";
import { AppState } from "./context/app/AppState";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import SignIn from "./components/signIn/SignIn";
import AppContainer from "./components/appContainer/AppContainer";
import PublicEventViewer from "./components/global/PublicEventViewer";

// 👇 You will build this component

function App() {
  return (
    <div>
      {" "}
      <AuthenticatedTemplate>
        <AppState>
          <AppContainer />
        </AppState>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Router>
          <AppState>
            {" "}
            <UnauthenticatedView />
          </AppState>
        </Router>
      </UnauthenticatedTemplate>
    </div>
  );
}

function UnauthenticatedView() {
  const location = useLocation();

  // Extract pathname
  const { pathname } = location;

  // Check if the path matches /publicView/:event_id
  const match = pathname.match(/^\/publicView\/[^/]+$/);

  return (
    <Routes>
      {match ? (
        <Route path="/publicView/:event_id" element={<PublicEventViewer />} />
      ) : (
        <Route path="*" element={<SignIn />} />
      )}
    </Routes>
  );
}

export default App;
